import Rete from "rete";
import { NumberSocket } from "../../rete-controls/NumberControl.js";
import AnyTypeSocket from "../../../Utils/CommonSockets";
import {ToggleSocket } from "../../rete-controls/ToggleControl.js"

export default class ProcessTriggerComponent extends Rete.Component {
  constructor() {
    super("Process Trigger"); // name
    this._categories = ["Interval Nodes"];
    this._currentInterval = 10;
    this._currentId = 0;
    this._wasTrue = false;
  }

  builder(node) {
    let inp1 = new Rete.Input("in1", "On/Off (Toggle)", ToggleSocket);
    let inp2 = new Rete.Input("in2", "Interval (Num)", NumberSocket);
    return node.addInput(inp1).addInput(inp2);
  }
  setNextUID(){
    if (this._currentId == Number.MAX_SAFE_INTEGER - 10) {
      this._currentId = 0;
    } else {
      this._currentId = this._currentId + 1;
    }
  }
  worker(node, inputs, outputs) {
    let in1 = inputs["in1"];
    let in2 = inputs["in2"];
    if (in2.length !== 0 && !Number.isNaN(in2[0]) && in1.length !== 0 && in1[0] === true) {
      this._wasTrue;
      in2 = +in2 >= 10 ? +in2 : 10;
      if (this._currentInterval !== in2) {
        this.setNextUID();
      }
      let myId = this._currentId;
      new Promise(resolve => setTimeout(resolve, in2)).then(r => {
        if (this._currentId === myId) {
          this.editor.trigger("process");
        } else {
          console.log("Current Id Changed");
        }
      });
    }else if( this._wasTrue){
      this._wasTrue = false;
      this.setNextUID();
    }
  }
}

//ReteComponentStore.add(new NumberDisplayComponent());
